import { z } from '@harvestiq/zod';
import { sharedEndorsementSchema } from './shared';
import { dbLrpEndorsementSchema } from './db-lrp-endorsement';

export const lrpEndorsementSchema = dbLrpEndorsementSchema.merge(
  sharedEndorsementSchema
);

export type LrpEndorsement = z.infer<typeof lrpEndorsementSchema>;
